import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { SelectChangeEvent } from '@mui/material/Select';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize } from '../../../theme';
import { QUESTION_TYPE } from '../../Modals/DashboardModal/constants';
import { HotAlertSelectFilterStyled, HotAlertMenuItemStyled, StyledHotAlertSelectFormControl } from './styled';

type HotAlertFilterDropdownProps = {
    columnId: string
    selectedFilterValues: string[]
    handleSelectedFilterValues: (property: string, filterValues: string[], filterType: QUESTION_TYPE) => void
    filterValues: string[]
}

export default function HotAlertFilterDropdown(props: HotAlertFilterDropdownProps) {
    const { columnId, selectedFilterValues, handleSelectedFilterValues, filterValues } = props;
    const [actualFilterValues, setActualFilterValues] = React.useState<string[]>(selectedFilterValues);
    const [openFilterSelect, setOpenFilterSelect] = useState(false);
    const { t } = useTranslation('dashboard');

    const handleChange = (event: SelectChangeEvent<typeof actualFilterValues>) => {
        const {
            target: { value },
        } = event;
        if (value.includes('null')) {
            setActualFilterValues([]);
        } else {
            setActualFilterValues(typeof value === 'string' ? value.split(',') : value);
            handleSelectedFilterValues(columnId, typeof value === 'string' ? value.split(',') : value, QUESTION_TYPE.CLOSED_DATA);
        }
    };

    const closeSelectFilter = (e: React.ChangeEvent) => {
        const targetRole = e.target.getAttribute('role');
        if (targetRole === 'option' && e.target.getAttribute('data-value') !== 'null') {
            setOpenFilterSelect(true);

            return;
        }
        if (targetRole === 'option' && e.target.getAttribute('data-value') === 'null') {
            setOpenFilterSelect(false);
            handleSelectedFilterValues(columnId, [], QUESTION_TYPE.CLOSED_DATA);

            return;
        }
        if (targetRole === 'button') {
            setOpenFilterSelect(true);

            return;
        }

        setOpenFilterSelect(false);
    };

    return (
        <StyledHotAlertSelectFormControl sx={{ m: 1, minWidth: 180, margin: '0px 5px' }}>
            <HotAlertSelectFilterStyled
                IconComponent={ArrowDropDownRoundedIcon}
                id="hot-alert-filter-select"
                labelId="hot-alert-filter-select"
                onChange={handleChange}
                onClick={closeSelectFilter}
                onOpen={() => setOpenFilterSelect(true)}
                open={openFilterSelect}
                renderValue={(selected: Array<string>) => {
                    if (actualFilterValues.length === 0) {
                        return t('filter.selectFilter');
                    }

                    return selected
                        .map((name) => name)
                        .join(', ');
                }}
                sx={actualFilterValues.length > 0 ? { color: colors.grey100 } : { color: colors.grey1500 }}
                value={actualFilterValues}
                variant="standard"
                displayEmpty
                multiple
            >
                <HotAlertMenuItemStyled sx={{ fontSize: fontSize.sm, color: colors.grey400, fontStyle: 'italic' }} value='null' disableRipple>
                    {t('filter.noFilter')}
                </HotAlertMenuItemStyled>
                {filterValues.map((name) => (
                    <HotAlertMenuItemStyled
                        key={name}
                        value={name}
                        disableRipple
                    >
                        {name}
                    </HotAlertMenuItemStyled>
                ))}
            </HotAlertSelectFilterStyled>
        </StyledHotAlertSelectFormControl>
    );
}
